// extracted by mini-css-extract-plugin
export var layoutContainer = "_an-0";
export var layoutContainerNoRounding = "_an-6";
export var layoutContainerOpen = "_an-5";
export var layoutContainerResizing = "_an-1";
export var mainContent = "_an-2";
export var resizeDivider = "_an-3";
export var slidePanel = "_an-4";